import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledSection = styled(Box)`
  padding: ${themeSpace(9)} ${themeSpace(7)} ${themeSpace(4)};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(8)};
    padding: ${themeSpace(8)} ${themeSpace(7)} ${themeSpace(4)};
  }
  ${themeMediaQuery('md')} {
    padding: ${themeSpace(9)} 0 ${themeSpace(4)};
  }
`;

export const StyledNavWrapper = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  padding: ${themeSpace(7)} 0 ${themeSpace(4)};
  gap: ${themeSpace(7)};
  display: flex;
  overflow: auto;
`;

export const StyledText = styled(Text)`
  color: #767676;
  :hover {
    color: ${themeColor('mono1')};
  }
`;

export const StyledWrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  ${themeMediaQuery('md')} {
    width: auto;
  }
`;
